export default __webpack_public_path__ + "static/media/intro_disc.4f43c2e6.png";